import React from "react";
import "./App.css";
import { BrowserRouter } from "react-router-dom";
import Routing from "./router";
import { BUILD_PATH } from "./constants/app.constants";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "bootstrap/dist/css/bootstrap.css";
import "../src/style/style.css";
import "../src/style/responsive.css";

const App = () => {
  return (
    <BrowserRouter basename={BUILD_PATH ? `/${BUILD_PATH}` : undefined}>
      <Routing />
    </BrowserRouter>
  );
};

export default App;
